export default __webpack_public_path__ + "static/media/ico-aws-red-shift-score-high.f110b081.svg";